import { render, staticRenderFns } from "./mensajeModal.vue?vue&type=template&id=6d8f45f7"
import script from "./mensajeModal.vue?vue&type=script&lang=js"
export * from "./mensajeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports